import { endOfDay, isAfter } from 'date-fns';

export const toServiceDateInstant = (performedOn: Date, now: Date = new Date()): Date => {
    const endOfPerformedDay = endOfDay(performedOn);

    return isAfter(endOfPerformedDay, now) ? now : endOfPerformedDay;
};
